/**
 * 选择区域
 */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import styles from './SetArea.module.scss';
import { Modal, message, Tree, Input } from 'antd';
import model from '@/reducers/operation/company/model';
import { getTreeArr, getListArr } from '../utils';

const { Search } = Input;

const SetArea = ({
    getCompanyOwnAreaTree,
    companyOwnAreaTree,
    closeModal,
    data: {
        companyInfoId = ''
    } = {}
}) => {

    const [expandedKeys, setExpandedKeys] = useState([]);
    const [checkedKeys, setCheckedKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    const [treeData, setTreeData] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [saveKeys, setSaveKeys] = useState([]);

    const changeKey = (list) => {
        return list.map(item => {
            let ele = {};
            ele.key = item.id;
            ele.title = item.areaName;
            ele.parentId = item.parentId;
            if (item.children) {
                ele.children = changeKey(item.children);
            }
            return ele;
        });
    };

    useEffect(() => {
        getCompanyOwnAreaTree();
    }, []);

    useEffect(() => {
        setTreeData(changeKey(companyOwnAreaTree));
    }, [companyOwnAreaTree]);

    const onAffirm = () => {
        const toLine = () => {
            let dataList = [];
            for (const f of treeData) {
                let lastItem = {
                    fId: f.key,
                    provinceName: f.title,
                };
                if (f.children) {
                    for (const s of f.children) {
                        lastItem = {
                            ...lastItem,
                            sId: s.key,
                            cityName: s.title,
                        };
                        if (s.children) {
                            for (const t of s.children) {
                                lastItem = {
                                    ...lastItem,
                                    tId: t.key,
                                    areaName: t.title,
                                    key: `${lastItem.fId}${lastItem.sId}${t.key}`
                                };
                                if (checkedKeys.includes(t.key)) {
                                    dataList.push(t.key);
                                }
                            }
                        }
                    }
                }

            }
            return dataList;
        };
        http('/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.setAreaWithCompany', { companyInfoId, areaIds: toLine() }, 'POST')
            .then(() => {
                message.success('设置区域操作成功');
                closeModal(true);
            })
            .catch(err => message.error(err.message));
    };

    const onExpand = (expandedKeysValue) => {
        setExpandedKeys(expandedKeysValue);
        setAutoExpandParent(false);
    };

    const onCheck = (checkedKeysValue, e) => {
        setCheckedKeys(checkedKeysValue);
    };

    const onSelect = (selectedKeysValue) => {
        setSelectedKeys(selectedKeysValue);
    };

    const onSearch = value => {
        let list = getListArr(treeData, 'key', 'parentId', 'children', null, false, true).filter(item => item.title.includes(value));
        let keys = list.map(item => (item.key));
        setExpandedKeys(value ? keys : []);
        setSaveKeys(value ? keys : []);
        setSearchValue(value);
        setAutoExpandParent(true);
    };

    const loop = data => {
        let curList = [...data];
        if (searchValue) {
            let list = getListArr(curList, 'key', 'parentId', 'children', null, false, true).filter(item => saveKeys.includes(item.parentId) || saveKeys.includes(item.key));
            curList = getTreeArr(list, 'key', 'parentId', 'children', 'title', false);;
        }
        curList = curList.map(item => {
            const index = item.title.indexOf(searchValue);
            const beforeStr = item.title.substr(0, index);
            const afterStr = item.title.substr(index + searchValue.length);
            const title =
                index > -1 ? (
                    <span>
                        {beforeStr}
                        <span style={{ color: '#f50 ' }}>{searchValue}</span>
                        {afterStr}
                    </span>
                ) : (
                    <span>{item.title}</span>
                );
            if (item.children) {
                return { title, key: item.key, children: loop(item.children) };
            }

            return {
                title,
                key: item.key,
            };
        });
        return curList;
    };

    return <Modal
        width={500}
        centered
        title='选择区域'
        visible={true}
        confirmLoading={false}
        bodyStyle={{ paddingRight: '10px' }}
        onOk={onAffirm}
        onCancel={() => closeModal(false)}
        destroyOnClose={true}
        keyboard={true}
        maskClosable={false}
        cancelText='取消'
        okText='确认'
    >
        <div className={styles.container}>
            <Search
                style={{ marginBottom: 8 }}
                placeholder='请输入省/市/区名称'
                onSearch={onSearch}
            />
            <Tree
                style={{ height: '400px', overflowY: 'auto', marginTop: '10px' }}
                checkable
                onExpand={onExpand}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                onSelect={onSelect}
                selectedKeys={selectedKeys}
                treeData={loop(treeData)}
            />
        </div>
    </Modal>;
};

SetArea.propTypes = {
    data: PropTypes.object,
    getCompanyOwnAreaTree: PropTypes.func,
    companyOwnAreaTree: PropTypes.array,
    closeModal: PropTypes.func
};

SetArea.defaultProps = {
    companyOwnAreaTree: []
};

export default connect((state) => ({
    companyOwnAreaTree: state.operationCompany.companyOwnAreaTree,
}), {
    ...model.actions,
})(SetArea);
